import { useMutation } from 'react-query'
import useApi from '../../../hooks/use-api'
import useCache from '../../../hooks/use-cache'
import useToasts from '../../../hooks/use-toasts'
import useRefreshDiscussions from './use-refresh-discussions'

const useParticipate = ({
    discussionId,
    onnSuccess = () => {}
} = {}) => {
    const { api, url, endpoints } = useApi()
    const { refreshDiscussions } = useRefreshDiscussions({ onRefreshed: onnSuccess })
    const { clearCache } = useCache({ key: ['participations', discussionId ], onReload: refreshDiscussions })
    const { toastError } = useToasts({
        errorMessage: 'Error sending message'
    })
    const [participate, { isLoading }] = useMutation(
        (content) => api.post(url(endpoints.discussionParticipations, { discussionId }), { content }),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    return {
        isLoading,
        participate
    }
}

export default useParticipate
